// The perception HUD is live again by default. Set this explicitly to false
// and rebuild whenever the public surface needs to be withheld temporarily.
const configuredValue = String(process.env.REACT_APP_LIVE_PERCEPTION_UI || "")
  .trim()
  .toLowerCase();

export const LIVE_PERCEPTION_UI_ENABLED = configuredValue !== "false";
